<template>
  <div>
    <div style="padding: 20px 20px 50px;">
      <div class="user-header-k">
        <el-form :inline="true" :model="form" class="demo-form-inline">
              <el-form-item label="搜索：">
                <el-input
                  v-model="keyword"
                  placeholder="请输入关键字"
                  @keyup.enter.native="searchTo()"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="searchTo()">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addManage()">添加用户</el-button>
              </el-form-item>
          </el-form>
      </div>
      <div class="pagination-table-k">
        <pagination-table style="width: 98%;margin-left: auto;margin-right: auto;" ref="table" :data="tableData"
          :columns="columns" :actions="actions" :loader="fetchUserInfo" :async="true" :pageSizes="[20]"
          colWidth="400px" ></pagination-table>
      </div>
     
    </div>
    <el-dialog :show-close="false" v-drag:common :title="dialog.isEdit ? '编辑用户' : '新增用户'" :visible="dialog.visible"
      @close="dialog.visible = false" width="500px"   >
      <el-form class="mt20 mr30" :rules="dialog.rule" label-width="80px" label-position="left" :model="dialog.data"
        ref="dialog">
        <el-row  :style="{marginRight:'30px'}">
          <el-form-item label="用户名" prop="userCode">
            <el-input v-model="dialog.data.userCode"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="dialog.data.name"  prop="name"></el-input>
          </el-form-item>
          <el-form-item label="邮箱"  prop="userMail">
            <el-input v-model="dialog.data.userMail" ></el-input>
          </el-form-item>

          <el-form-item label="手机号" prop="userTel">
            <el-input v-model="dialog.data.userTel"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="state">
            <div style="width: 210px;">
              <el-radio v-model="dialog.data.state" label="0" :style="{marginLeft:'30px'}">禁用</el-radio>
              <el-radio v-model="dialog.data.state" label="1">启用</el-radio>
            </div>
           
          </el-form-item>
          <el-form-item label="角色" prop="role" :style="{width:'270px' }">
            <el-select v-model="dialog.data.roleId" @change="selectChange" placeholder="请选择" :style="{width: '100%',marginLeft:'-10px'}">
              <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.roleId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row class="mb20" :style="{marginTop:'30px',marginLeft:'0px'}">
          <el-form-item>
            <div class="dialog-isReadOnly-bu-k">
              <el-button @click="dialog.visible = false" id="quxiao-bu-k">取消</el-button>
              <el-button :disabled="dialog.isReadOnly" @click="save()" type="primary" :loading="dialog.loading">
                {{dialog.isEdit ? '保存' : '添加'}}</el-button> 
             
            </div>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
  import { getToken } from '@/utils';

  export default {
    data() {
      return {
        visible: false,
        headers: {
          apiKey: getToken()
        },
   
        tableData: [],
        // 获取角色列表
        roleList: [],
        tableLoading: false,
        page: 0,
        keyword: '',
        hrefUrl: `${process.env.VUE_APP_API_HOST}/manage/project/getTemplateFile?fileName=user.xlsx`,
        action: `${process.env.VUE_APP_API_HOST}/manage/user/uploadFile`,
        columns: [
          {
            prop: 'userCode',
            label: '用户名'
          },
          {
            prop: 'name',
            label: '姓名'
          },
          {
            prop: 'userMail',
            label: '邮箱'
          },
          {
            prop: 'userTel',
            label: '手机号'
          },
          {
            prop: 'state',
            label: '状态',
            render: (y, scope) => {
              if (scope.row.state === 0) {
                return <span>禁用</span>;
              } else {
                return <span>启用</span>;
              }
            }
          },
          {
            prop: 'roleName',
            label: '角色'
          }
        ],
        actions: [
          {
            label: '修改',
            type: 'primary',
            plain: true,
            style: 'btn',
            onClick: (index, row) => {
              this.edit(row);
            }
          },
          {
            label: '删除',
            type: 'danger',
            plain: true,
            style: 'btn',
            onClick: (index, row) => {
              this.del(row);
            }
          },
          {
            label: '重置密码',
            type: 'danger',
            plain: true,
            style: 'btn',
            onClick: (index, row) => {
              this.reset(row);
            }
          }
        ],
        dialog: {
          isEdit: false,
          visible: false,
          isReadOnly: false,
          loading: false,
          rule: {
            userCode: [
              {
                required: true,
                message: '请输入用户名',
                trigger: 'blur'
              },
              {
                min: 2,
                max: 10,
                message: '长度在2到10个字符',
                trigger: 'blur'
              },
              {
                validator: (rule, value, callback) => {
                  if (value.trim()) {
                    callback();
                  } else {
                    callback(new Error('请输入正确的用户名'));
                  }
                },
                trigger: 'blur'
              }
            ],
            name: [
              {
                required: true,
                message: '请输入姓名',
                trigger: 'blur'
              },
              {
                min: 2,
                max: 10,
                message: '长度在2到10个字符',
                trigger: 'blur'
              },
              {
                validator: (rule, value, callback) => {
                  if (value.trim()) {
                    callback();
                  } else {
                    callback(new Error('请输入正确的姓名'));
                  }
                },
                trigger: 'blur'
              }
            ],
            userMail: [
              {
                required: true,
                message: '请输入邮箱地址',
                trigger: 'blur'
              },
              {
                validator: (rule, value, callback) => {
                  if (!value) {
                    return callback();
                  }
                  let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
                  if (String(value).match(reg)) {
                    callback();
                  } else {
                    callback(new Error('请输入正确的邮箱地址'));
                  }
                },
                trigger: 'blur'
              }
            ],
            userTel: [
              {
                required: true,
                message: '请输入联系电话',
                trigger: 'blur'
              },
              {
                validator: (rule, value, callback) => {
                  if (String(value).match(/^1[3-9]\d{9}$/)) {
                    callback();
                  } else {
                    callback(new Error('请输入正确的手机号'));
                  }
                },
                trigger: 'blur'
              }
            ],
            state: [
              {
                required: true,
                message: '请选择状态',
                trigger: 'blur'
              }
            ]

          },
          data: {}
        }
      };
    },
    computed: {
    },
    watch: {
      customerKeyword(keywords) {
        if (!keywords) {
          this.roleId = null;
        }
      }
    },
    methods: {
      async fetchUserInfo(options) {
        // console.log(options)
        this.tableLoading = true;
        const res = await this.$fetch('/windfarm/user/getUserList', {
          module: 'manage',
          params: { pageNo: options.page, keyword: this.keyword },
          showError: true
        });
        const data = res.data.data.rows;
        data.forEach(item => {
          this.roleList.forEach(val => {
            if (item.roleId === val.roleId) {
              item.roleName = val.roleName;
            }
          });
        });
        this.tableData = data;
        this.tableLoading = false;
      
        return {
          data: res.data.data.rows,
          total: res.data.data.total
         
        };
       
      },
      async submit() {
        this.$refs.upload.submit();
      },

      async fetchRole() {
        const res = await this.$fetch('/windfarm/roleManage/getRoleList', {
          module: 'manage',
          showError: true
        });
        this.roleList = res.data.defaultParam;
      },
      edit(val) {
        this.dialog.isEdit = true;
        this.dialog.visible = true;

        this.dialog.data = Object.assign(
          {
            createTime: val.createTime,
            lastLoginTime: val.lastLoginTime,
            name: val.name,
            userCode: val.userCode,
            userMail: val.userMail,
            userTel: val.userTel,
            roleId: val.roleId,
            state: val.state,
            userId: val.userId
          },
          val
        );
        this.dialog.data.state = this.dialog.data.state.toString();
        if (this.$refs.dialog) {
          this.$refs.dialog.clearValidate();
        }
      },
      addManage() {
        this.dialog.visible = true;
        this.dialog.isEdit = false;
        this.dialog.data = {
          createTime: '',
          lastLoginTime: '',
          name: '',
          userCode: '',
          userMail: '',
          userTel: '',
          roleId: '',
          state: '1',
          userId: ''
        };
        this.dialog.data.state = '1';
        if (this.$refs.dialog) {
          this.$refs.dialog.clearValidate();
        }
      },
      del(val) {
        this.$confirm(`确定删除用户"${val.name}"?`).then(() => {
          this.$postForm('/windfarm/user/delUser', {
            module: 'manage',
            params: {
              userId: val.userId
            },
            showError: true,
            showSuccess: true
          }).then(() => {
            this.$refs.table.load();
            // console.log(this.$refs.table._data)
            // console.log(this.$refs.table._data.total)
            if(this.$refs.table._data.total == 0){
              this.fetchUserInfo({page:this.$refs.table._data.page-1,size:20})
            }
            // console.log( this.$refs.table._data.listData,'222')
          });
        });
      },
      reset(val) {
        this.$confirm(`确定将用户"${val.name}"的密码重置?`).then(() => {
          this.$postForm('/windfarm/user/resetPassword', {
            module: 'manage',
            params: {
              userId: val.userId
            },
            showError: true,
            showSuccess: true
          }).then(() => {
            this.$refs.table.load();
          });
        });
      },
      selectChange(val) {
        this.dialog.roleId = val;
      },
      save() {
        this.$refs.dialog.validate().then(() => {
          this.dialog.loading = true;
          let url = `/windfarm/user/saveUser?apiKey=${getToken()}`;
          // 编辑用户
          this.$fetch({
            url: url,
            method: 'post',
            data: {
              createTime: this.dialog.data.createTime,
              lastLoginTime: this.dialog.data.lastLoginTime,
              name: this.dialog.data.name,
              userCode: this.dialog.data.userCode,
              userMail: this.dialog.data.userMail,
              userTel: this.dialog.data.userTel,
              roleId: this.dialog.data.roleId,
              state: Number(this.dialog.data.state),
              userId: this.dialog.data.userId
            },
            module: 'manage',
            showError: true,
            showSuccess: true
          })
            .then(() => {
              this.dialog.loading = false;
              this.dialog.visible = false;
              return this.$refs.table.load();
            })
            .catch(() => {
              this.dialog.loading = false;
            });
        });
      },
      searchTo() {
        this.$refs.table.load({ page: 1 });
      }
    },
    created() {
      this.fetchRole();
    }
  };
</script>

<style lang="less" scoped>
  /* div /deep/ .el-input__suffix {
    right: -15px;
    -webkit-transition: all .3s;
    transition: all .3s;
} */
  #quxiao-bu-k {
    width: 82px;
    height: 33px;
    border-radius: 5px;
    color: #fff;
    background: #081A29;
  }
 .dialog-isReadOnly-bu-k{
  width: 100%;

 margin-right: 80px;
 }
</style>